import React from "react";
import PropTypes from "prop-types";

const LookFeatureInfo3dViewer = (props) => {

  const {glb, usdz, hdr, isMobile, arButtonOnly, arButton} = props;

  // ["https://app.box.com/s/jc8rp50pp0ju38t61d632nj91txuklvu.glb",
  // "https://app.box.com/s/2th92kec1afl6o2tb6nnz70su003oxwo.usdz",
  // "https://app.box.com/s/ikmcu24ishb1v44ptgekg8klor5ye6qk.hdr"]

  if (arButtonOnly) {
    return (
      <model-viewer ar=""
                    reveal="manual"
                    ar-modes="webxr scene-viewer quick-look"
                    camera-controls=""
                    src={glb}
                    ios-src={usdz}
                    environment-image={hdr}
                    class="look-icon"
                    alt="">
        {arButton}
      </model-viewer>
    )
  }

  return (
    <model-viewer id="model-viewer"
                  src={glb}
                  ios-src={usdz}
                  environment-image={hdr}
                  ar=""
                  exposure="1"
                  camera-controls=""
                  style={{width: "100%", height: isMobile ? "100%" : `calc(100% - 80px)`}}
                  aar-modes="webxr scene-viewer quick-look"
                  alt=""
                  quick-look-browsers="safari chrome">
      {arButton}
    </model-viewer>
  )
};

LookFeatureInfo3dViewer.propTypes = {
  glb: PropTypes.string,
  usdz: PropTypes.string,
  hdr: PropTypes.string,
  isMobile: PropTypes.bool,
  arButton: PropTypes.element,
}

export default LookFeatureInfo3dViewer
